import { render, staticRenderFns } from "./ProjectTimePoint.vue?vue&type=template&id=27de3a52&scoped=true"
import script from "./ProjectTimePoint.vue?vue&type=script&lang=js"
export * from "./ProjectTimePoint.vue?vue&type=script&lang=js"
import style0 from "./ProjectTimePoint.vue?vue&type=style&index=0&id=27de3a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27de3a52",
  null
  
)

export default component.exports